const userCompany = {
  short: '',
  long: '',
  color: '',
}
export default userCompany